/* eslint-disable global-require */
/* eslint-disable react/no-unused-state */
import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import {
    BrowserRouter,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { axiosInstance, inIframe } from '@appblocks/frontend/client/utils';
import posthog from 'posthog-js';
import Loading from '@appblocks/frontend/client/Components/Loading';
import 'regenerator-runtime/runtime';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import 'react-grid-layout/css/styles.css';
import '@xyflow/react/dist/style.css';
import '@appblocks/frontend/styles/App.css';
import '@appblocks/frontend/client/Components/DeviceDashboard/widgets.css';
import '@appblocks/frontend/client/Components/DeviceDashboard/dashboard.css';
import { addMessage, removeMessage } from '@appblocks/frontend/redux/messagesSlice';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Page404 from '@appblocks/frontend/client/Pages/Page404';
import NewAppVersionAlert from '@appblocks/frontend/client/Components/NewAppVersionAlert';
import Sidenav from '@appblocks/frontend/cloudclient/Sidenav';
import marked from 'marked';
import { getSuperTokensRoutesForReactRouterDom } from 'supertokens-auth-react/ui';
import {
    debuggerTaskStop,
} from '@appblocks/frontend/redux/debugSlice';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';
import { PreBuiltUIList, SuperTokensConfig } from '@appblocks/frontend/config/st_config';
import Header from '@appblocks/frontend/client/Header';
import PageDeviceGroups from '@appblocks/frontend/cloudclient/PageDeviceGroups';
import PageDeviceGroupDetails from '@appblocks/frontend/cloudclient/PageDeviceGroupDetails';
import PageCloudSettings from './cloudclient/PageCloudSettings';
import PageBoardDesigner from './client/Pages/PageBoardDesigner';
import TawkComponent from '@appblocks/frontend/client/Components/TawkComponent';


const mapStateToProps = (state) => {
    return {
        featureFlags: state.user.featureFlags,
        user: state.user.user,
        loaded: state.user.loaded && state.workspaces.loaded,
        logoutURL: state.user.logoutURL,
    };
};

const PageExplore = lazy(() => import('@appblocks/frontend/client/Pages/PageExplore'));
const PageNewProject = lazy(() => import('@appblocks/frontend/client/Pages/PageNewProject'));
const PageEditProject = lazy(() => import('@appblocks/frontend/client/Pages/PageEditProject'));
const PagePrintBoardLayout = lazy(() => import('@appblocks/frontend/client/Pages/PagePrintBoardLayout'));
const PageSample = lazy(() => import('@appblocks/frontend/client/Pages/PageSample'));
const PageHome = lazy(() => import('@appblocks/frontend/client/Pages/PageHome'));
const ProductWidget = lazy(() => import('@appblocks/frontend/client/Pages/ProductWidget'));
const PageSignInAndUp = lazy(() => import('@appblocks/frontend/client/Pages/PageSignInAndUp'));
const PageSignup = lazy(() => import('@appblocks/frontend/client/Pages/PageSignup'));
const PageAccount = lazy(() => import('@appblocks/frontend/client/Pages/PageAccount'));
const PageWorkspaceSettings = lazy(() => import('@appblocks/frontend/client/Pages/PageWorkspaceSettings'));
const PageTempSettings = lazy(() => import('@appblocks/frontend/client/Pages/PageTempSettings'));

const PageCloudHome = lazy(() => import('@appblocks/frontend/cloudclient/PageCloudHome'));
const PageDevices = lazy(() => import('@appblocks/frontend/cloudclient/PageDevices'));
const PageDeviceDetails = lazy(() => import('@appblocks/frontend/cloudclient/PageDeviceDetails'));
const PageDeviceTemplates = lazy(() => import('@appblocks/frontend/cloudclient/PageDeviceTemplates'));
const PageDeviceTemplateEdit = lazy(() => import('@appblocks/frontend/cloudclient/PageDeviceTemplateEdit'));
const PageWorkflows = lazy(() => import('@appblocks/frontend/cloudclient/PageWorkflows'));
const PageWorkflowDetails = lazy(() => import('@appblocks/frontend/cloudclient/PageWorkflowDetails'));
const PageApps = lazy(() => import('@appblocks/frontend/cloudclient/PageApps'));
const PageAppDetails = lazy(() => import('@appblocks/frontend/cloudclient/PageAppDetails'));
const PageDataSources = lazy(() => import('@appblocks/frontend/cloudclient/PageDataSources'));
const AppEditor = lazy(() => import('@appblocks/frontend/cloudclient/AppEditor'));
const PageDeviceApps = lazy(() => import('@appblocks/frontend/cloudclient/PageDeviceApps'));
const PageEvents = lazy(() => import('@appblocks/frontend/cloudclient/PageEvents'));

const store = require('@appblocks/frontend/redux/store').default;

function WaitingComponent(TheComponent) {
    return props => (
        <Suspense fallback={<Loading />}>
            <TheComponent {...props} />
        </Suspense>
    );
}

if (process.env.NODE_ENV === 'production'
    && !window.IS_PLAYWRIGHT
    && !inIframe()) {
    Sentry.init({
        dsn: process.env.SENTRY_REACT_DSN || 'https://cb9dbb92edccfd90c4dc015f40f3639e@o4505779979943936.ingest.sentry.io/4506572902891520',
        integrations: [
            new Sentry.BrowserTracing({
                tracePropagationTargets: ['localhost', /^https:\/\/api.appblocks\.io\/api/],
            }),
            new Sentry.Replay({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

class AppContainer extends Component {
    // eslint-disable-next-line react/sort-comp

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };

        this.renderMessages = this.renderMessages.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.renderMarkdownMessage = this.renderMarkdownMessage.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidMount() {
        if (!window.location.host.includes('127.0.0.1')
            && !window.location.host.includes('localhost')
            && !inIframe()) {
            posthog.init('phc_iuiZbkuvquOnkaQTy3bRBTgwxAaXhUJVztY7XeRObrJ', { api_host: 'https://app.posthog.com' });
        }
        store.dispatch({
            type: 'user/loadSession',
        });
        store.dispatch({
            type: 'workspaces/getWorkspaces',
        });
    }

    componentDidCatch(error, errorInfo) {
        if (error.name === 'ChunkLoadError') {
            window.location.reload();
        }
        posthog.capture('exception', error);
        console.log('error', error);
    }

    renderLoading() {
        return (
            <div className="container" role="main">
                <Loading />
            </div>
        );
    }

    renderMarkdownMessage(message) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: marked(message, { sanitize: false }),
                }}
            />
        );
    }

    renderMessage(message) {
        if (message.format && message.format === 'markdown') {
            return this.renderMarkdownMessage(message.message);
        }
        return (
            <>
                {message.message.split('\r\n').map((line, index) => (
                    <span key={index}>
                        {line}
                        <br />
                    </span>
                ))}
            </>
        );
    }

    renderMessages() {
        const Component = connect((state) => {
            return {
                messages: state.messages,
            };
        })((props) => {
            return (
                <ToastContainer
                    position="bottom-end"
                    className="p-3 position-fixed mb-4 messages-toast-container"
                >
                    {props.messages.messages.map((message, index) => (
                        <Toast
                            onClose={() => this.props.removeMessage(message.id)}
                            key={index}
                        >
                            <Toast.Header
                                closeButton={(message.delay !== 0
                                    && message.delay !== undefined)
                                    || message.dismissable}
                            >
                                <strong className="me-auto">{message.title}</strong>
                            </Toast.Header>
                            <Toast.Body>
                                <div className="row">
                                    <div className="col-10">
                                        {this.renderMessage(message)}
                                    </div>
                                    <div className="col-2">
                                        {message.action && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm float-end"
                                                onClick={() => {
                                                    store.dispatch({
                                                        type: message.action.type,
                                                        payload: message.action.payload,
                                                    });
                                                    if (message.delay) {
                                                        this.props.removeMessage(message.id);
                                                    }
                                                }}
                                            >
                                                {message.action.label}
                                            </button>
                                        )}
                                        {message.cancellable && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm float-end"
                                                onClick={() => {
                                                    store.dispatch({
                                                        type: debuggerTaskStop.type,
                                                        payload: message.id,
                                                    });
                                                    this.props.removeMessage(message.id);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {message.progress !== undefined && (
                                    <div style={{ marginTop: 5 }}>
                                        <ProgressBar now={message.progress} />
                                    </div>
                                )}
                            </Toast.Body>
                        </Toast>
                    ))}
                </ToastContainer>
            );
        });

        return <Component />;
    }

    render() {
        if (this.state && this.state.hasError) {
            return (
                <div className="container" role="main">

                    <h1>Something went wrong.</h1>
                    <p>
                        The problem has been logged and we will look into it.
                    </p>
                    <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                        Reload Page
                    </button>
                </div>
            );
        }
        if (!this.props.loaded) {
            return this.renderLoading();
        }
        return (
            <BrowserRouter>

                {getSuperTokensRoutesForReactRouterDom(require('react-router-dom'), PreBuiltUIList)}
                <Switch>
                    <Route path="/pages/:appId" exact component={WaitingComponent(AppEditor)} />
                    <Route path="/app/project/edit/:projectId/print-layout" exact component={WaitingComponent(PagePrintBoardLayout)} />
                    <Route path="/app/project/edit/:projectId?" component={WaitingComponent(PageEditProject)} />
                    <Route path="/app" exact component={WaitingComponent(PageHome)} />
                    <Route path="/auth" exact component={WaitingComponent(PageSignInAndUp)} />
                    <Route path="/explore" component={WaitingComponent(PageExplore)} />
                    <Route path="/app/project/embed" component={WaitingComponent(PageSample)} />
                    <Route path="/app/project/new" exact component={WaitingComponent(PageNewProject)} />
                    <Route path="/workspace/settings" component={WaitingComponent(PageTempSettings)} />
                    <Route path="/embed" exact component={WaitingComponent(ProductWidget)} />
                    <Route path="/boarddesigner" exact component={WaitingComponent(PageBoardDesigner)} />
                    <Route
                        path="/"
                        render={({ match: { url } }) => (
                            <div className="app">
                                <Sidenav />
                                <main className="page-wrapper bg-body-tertiary">
                                    <div className="container-fluid h-100">
                                        {/* <Header /> */}
                                        <Route path="/" exact component={WaitingComponent(PageCloudHome)} />
                                        <Route path="/apps" exact component={WaitingComponent(PageDeviceApps)} />
                                        <Route path="/devices" exact component={WaitingComponent(PageDevices)} />
                                        <Route path="/devices/:deviceId" component={WaitingComponent(PageDeviceDetails)} />
                                        <Route path="/groups" exact component={WaitingComponent(PageDeviceGroups)} />
                                        <Route path="/groups/:groupId" exact component={WaitingComponent(PageDeviceGroupDetails)} />
                                        <Route path="/devicetemplates" exact component={WaitingComponent(PageDeviceTemplates)} />
                                        <Route path="/devicetemplates/:templateId" exact component={WaitingComponent(PageDeviceTemplateEdit)} />
                                        <Route path="/pages" exact component={WaitingComponent(PageApps)} />

                                        <Route path="/workflows" exact component={WaitingComponent(PageWorkflows)} />
                                        <Route path="/workflows/:workflowId" exact component={WaitingComponent(PageWorkflowDetails)} />
                                        <Route path="/datasources" exact component={WaitingComponent(PageDataSources)} />
                                        <Route path="/events" exact component={WaitingComponent(PageEvents)} />
                                        <Route path="/settings" exact component={WaitingComponent(PageCloudSettings)} />
                                        <Route path="/settings/:setting" exact component={WaitingComponent(PageCloudSettings)} />
                                    </div>
                                </main>
                            </div>
                        )}
                    />
                </Switch>
                {/* <Route component={Page404} /> */}

                {/* <Redirect to='/app' /> */}
                <NewAppVersionAlert />
                {this.renderMessages()}
                <TawkComponent />

            </BrowserRouter>
        );
    }
}
// export default AppContainer;
export default connect(mapStateToProps, {
    addMessage,
    removeMessage,
})(AppContainer);
